// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b762faec","179":"da7e398d","190":"9d4a35f6","220":"befbe1e9","328":"34961168","442":"1ee8d412","453":"78ac9f2f","462":"94ec371a","511":"02debcdc","557":"172d5bf6","574":"a7bfc9e7","596":"6c7543f4","618":"3b2ecf21","648":"717c553f","782":"ff035643","874":"573e4025"}[chunkId] + ".chunk.js";
};